import { useEffect, useLayoutEffect } from 'react';
import type { UFOExperience } from '@atlassian/ufo';
import type { CustomData } from '@atlassian/ufo-experimental/types';

interface EndStateConfig {
    force?: boolean;
    metadata?: CustomData;
}

export const UfoExperienceFailure = ({
    experience,
    config,
}: {
    experience: UFOExperience;
    config?: EndStateConfig;
}) => {
    useEffect(() => {
        // Since experience failure function is returning a promise, just executing it without waiting for it to resolve
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        experience.failure(config);
    }, [config, experience]);
    return null;
};

export const UfoExperienceSuccess = ({
    experience,
    config,
}: {
    experience: UFOExperience;
    config?: EndStateConfig;
}) => {
    useLayoutEffect(() => {
        // Since experience failure function is returning a promise, just executing it without waiting for it to resolve
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        experience.success(config);
    }, [config, experience]);
    return null;
};
